angular.module("awizApp")

.constant("ENV", "prod")

.constant("VERSION", "1.2.7")

;